import set from 'lodash/set';
import store from '@/store/store';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { REGIE } from '@/configuration/societe/societe';
import booleanConverter from '@/services/import/General/booleanConverter';
import genererDevisCommande from '@/services/devisCommandes/genererDevisCommande';
import { columnsFacture, columnsLigneFacture } from '@/services/import/facture/templateCommande';
import {
  TYPE_DEVIS,
  TYPE_COMMANDE,
  TYPE_FACTURE,
  NORMAL,
  SENS_VENTE,
  POURCENTAGE,
  MODULE_GESTION_COMMERCIALE,
} from '@/configuration/devisConf';
import { CATEGORIE_REGROUPEMENT } from '@/configuration/catalogue/produitConf';
import { COMMERCIAL, DIRECTEUR_COMMERCIAL, ASSISTANT_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import { cloneDeep } from 'lodash';
import formatDate from '@/services/general/formatIsoDate';
import calcul from '@/services/devisCommandes/calcul/calculCommandeDevis';
import calculDateEcheancier from '@/services/facture/dateDebutEcheancier';
import calculLigneCommandeNormal from '@/services/devisCommandes/calcul/calculLigneCommandeNormal';
import calculArrondi from '@/services/calcul/calculArrondi';

function generationEcheancierPaiment(facture) {
  const date = new Date(facture.dateDevisCommande);
  const dateEcheance = calculDateEcheancier(
    date,
    facture.delaiReglement?.delaiReglementDetail,
  );
  return {
    dateEcheance,
    montant: facture.montantTtc,
    modeReglementId: facture.modeReglementId,
    ordre: 1,
    actif: true,
  };
}

export function fillFactureWithData(commande, ligne, lignesCommande, utils) {
  const errors = [];
  const banColumnAuto = ['agence', 'annonceur', 'payeur', 'mandataire', 'donneurOrdre'];
  const intColumn = ['montantHt'];
  const boolColumn = ['renouvelable', 'reconductible'];
  const keys = Object.keys(ligne);
  // fait tout les columns facile
  for (let i = 0; i < keys.length; i += 1) {
    if (!banColumnAuto.includes(keys[i])) {
      if (boolColumn.includes(keys[i])) {
        set(commande, keys[i], booleanConverter(ligne[keys[i]]));
      } else if (keys[i].startsWith('date')) {
        set(commande, keys[i], formatDate(ligne[keys[i]]));
      } else if (intColumn.includes(keys[i])) {
        const num = Number(ligne[keys[i]]);
        set(commande, keys[i], num);
      } else {
        set(commande, keys[i], ligne[keys[i]]);
      }
    }
  }
  // generation des intervenants
  const intervenants = [
    ...new Set([ligne.annonceur.trim(), ligne.payeur.trim(), ligne.donneurOrdre.trim()]),
  ];
  commande.intervenants = intervenants.map(i => {
    const tier = utils.tiers.find(t => t.referenceExterne === i);
    if (!tier) {
      errors.push(`${i}_CLIENT_NOT_FOUND`);
      return null;
    }
    const intervenant = cloneDeep(tier);
    intervenant.tiersId = intervenant.id;
    delete intervenant.id;
    intervenant.donneurOrdre = ligne.donneurOrdre === i;
    intervenant.payeur = ligne.payeur === i;
    intervenant.mandataire = ligne.payeur === i && booleanConverter(ligne.mandataire);
    intervenant.annonceur = ligne.annonceur === i;
    intervenant.typeRepartition = POURCENTAGE;
    intervenant.repartition = ligne.payeur === i ? 100 : 0;
    if (commande.type === TYPE_FACTURE) {
      intervenant.destinataire = ligne.payeur === i;
      intervenant.destinataireComptable = ligne.payeur === i;
    }
    return intervenant;
  });
  // generation des utilisateur et agence a partir du store
  commande.agenceId = store.getters['societe/societeActive']?.agences.find(a => a.libelle?.toLowerCase() === ligne.agence?.toLowerCase().trim())?.id;
  if (!commande.agenceId) errors.push(`NO_MATCH_${columnsFacture.find(c => c.key === 'agence')?.label || 'X'}`);
  commande.commercialId = store.getters['parametres/parametre'](PARAMETRES_KEYS.utilisateur).find(u => u.decorator?.nomPrenom?.toLowerCase() === ligne.commercial?.toLowerCase().trim() && [COMMERCIAL, DIRECTEUR_COMMERCIAL].some(r => u.roles.includes(r)))?.id ?? null;
  commande.assistantId = store.getters['parametres/parametre'](PARAMETRES_KEYS.utilisateur).find(u => u.decorator?.nomPrenom?.toLowerCase() === ligne.assistant?.toLowerCase().trim() && u.roles.includes(ASSISTANT_COMMERCIAL))?.id ?? null;

  commande.modeReglement = utils.modes.find(m => {
    return m.libelle.toUpperCase() === commande.modeReglement.toUpperCase();
  });
  commande.modeReglementId = commande.modeReglement?.id;
  if (!commande.modeReglementId) errors.push(`${columnsFacture.find(c => c.key === 'modeReglement')?.label || 'X'}_NO_MATCH`);

  commande.delaiReglement = utils.delais.find(m => {
    return m.libelle.toUpperCase() === commande.delaiReglement.toUpperCase();
  });
  commande.delaiReglementId = commande.delaiReglement?.id;
  if (!commande.delaiReglementId) errors.push(`${columnsFacture.find(c => c.key === 'delaiReglement')?.label || 'X'}_NO_MATCH`);

  // generation des lignes de commandes
  const mappingligneCommande = { NORMAL: [] };
  for (let m = 0; m < lignesCommande.length; m += 1) {
    if (lignesCommande[m].codeProduit?.trim()) {
      if (mappingligneCommande[lignesCommande[m].codeProduit?.trim()]) {
        mappingligneCommande[lignesCommande[m].codeProduit.trim()].push(lignesCommande[m]);
      } else {
        mappingligneCommande[lignesCommande[m].codeProduit?.trim()] = [lignesCommande[m]];
      }
    } else {
      mappingligneCommande.NORMAL.push(lignesCommande[m]);
    }
  }
  const keysFromMapping = Object.keys(mappingligneCommande);
  for (let i = 0; i < keysFromMapping.length; i += 1) {
    if (keysFromMapping[i] === 'NORMAL') {
      const lignesNormales = [];
      for (let j = 0; j < mappingligneCommande.NORMAL.length; j += 1) {
        const ligneNormal = cloneDeep(mappingligneCommande.NORMAL[j]);
        delete ligneNormal.codeCommande;
        const produitsFound = utils.produits.filter(p => {
          return p.reference.toLowerCase() === ligneNormal.referenceProduit.toLowerCase().trim();
        });
        if (produitsFound.length === 1) {
          ligneNormal.produitId = produitsFound[0].id;
          ligneNormal.type = NORMAL;
          calculLigneCommandeNormal(ligneNormal);
          lignesNormales.push(ligneNormal);
        } else {
          errors.push(`LIGNE_COMMANDE_${ligneNormal.numLigne}_${columnsLigneFacture.find(c => c.key === 'referenceProduit')?.label || 'X'}_NO_MATCH`);
        }
      }
      if (lignesNormales.length > 0) {
        commande.lignesCommande = commande.lignesCommande.concat(lignesNormales);
      }
    } else {
      const ligneRegroupement = cloneDeep(mappingligneCommande[keysFromMapping[i]][0]);
      const produitsFound = utils.produits.filter(p => {
        return p.reference.toLowerCase() === ligneRegroupement.codeProduit.toLowerCase().trim();
      });
      if (produitsFound.length === 1) {
        ligneRegroupement.produitId = produitsFound[0].id;
        ligneRegroupement.libelle = ligneRegroupement.libelleProduit;
        ligneRegroupement.type = CATEGORIE_REGROUPEMENT;
        ligneRegroupement.dateDebut = formatDate(ligneRegroupement.dateDebut);
        ligneRegroupement.dateFin = formatDate(ligneRegroupement.dateFin);
      } else {
        errors.push(`LIGNE_COMMANDE_${ligneRegroupement.numLigne}_${columnsLigneFacture.find(c => c.key === 'codeProduit')?.label || 'X'}_NO_MATCH`);
      }
      ligneRegroupement.lignesCommande = [];
      for (let j = 0; j < mappingligneCommande[keysFromMapping[i]].length; j += 1) {
        const sousLigne = cloneDeep(mappingligneCommande[keysFromMapping[i]][j]);
        const produitsFound = utils.produits.filter(p => {
          return p.reference.toLowerCase() === sousLigne.referenceProduit
            .toString().toLowerCase().trim();
        });
        if (produitsFound.length === 1) {
          sousLigne.produitId = produitsFound[0].id;
          sousLigne.dateDebut = formatDate(sousLigne.dateDebut);
          sousLigne.dateFin = formatDate(sousLigne.dateFin);
          ligneRegroupement.lignesCommande.push(sousLigne);
        } else {
          errors.push(`LIGNE_COMMANDE_${sousLigne.numLigne}_${columnsLigneFacture.find(c => c.key === 'referenceProduit')?.label || 'X'}_NO_MATCH`);
        }
      }
      if (ligneRegroupement.produitId) commande.lignesCommande.push(ligneRegroupement);
    }
  }
  const montant = calculArrondi(commande.montantHt);
  calcul(commande);
  if (commande.montantHt !== montant) {
    errors.push('MONTANT_ERROR');
  }
  if (errors.length === 0 && commande.type === TYPE_FACTURE) {
    try {
      generationEcheancierPaiment(commande);
      commande.echeancierPaiement.forEach(echeance => {
        echeance.dateEcheance = formatDate(echeance.dateEcheance);
      });
    } catch (e) {
      errors.push('ECHEANCIER_PAIEMENT');
    }
  }

  if (errors.length > 0) throw errors;
  return commande;
}

export async function genererFacture(ligne, lignesCommande, utils) {
  const type = [TYPE_DEVIS, TYPE_COMMANDE, TYPE_FACTURE].find(t => {
    return t.toUpperCase() === ligne.type.toUpperCase();
  }) || TYPE_DEVIS;
  let commande = genererDevisCommande(type, NORMAL, store.getters['societe/societeActive'], SENS_VENTE, MODULE_GESTION_COMMERCIALE);
  commande.societeId = store.getters['societe/societeActiveId'];
  commande.role = REGIE;
  commande = (await fillFactureWithData(commande, ligne, lignesCommande, utils));
  return commande;
}
